import { gsap } from 'gsap';

class CustomAnimation {

  animateHeaderImage(element){
    gsap.to(element, {
      scrollTrigger: {
        trigger: '.header',
        start: '0% 0%',
        end: 'bottom 0%',
        markers: false,
        scrub: 0
      },
      y: '50%'
    });
  }

  animateFromBottom(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 75
      });
    });
  }

  animateButtonGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 50%',
          markers: false,
          scrub: 0
        },
        y: 75,
        scale: .9
      });
    });
  }
}

export default CustomAnimation;
